import { render } from "./post-index.vue?vue&type=template&id=24acf1d5"
import script from "./post-index.vue?vue&type=script&lang=js"
export * from "./post-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__